export default __webpack_public_path__ + "static/media/letter_head.70b86438.png";